module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 2758
// module chunks = 0